const doc = [({"copyable_code":({"instruction":"Copy", "copy":"Copy", "copied":"Copied"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;